import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"
import { IChannel } from "./channels"

export interface IChannelWhatsApp extends IChannel {}

export const channelsWhatsappCloudApi: IGenericModel<IChannelWhatsApp> = {
    ...generic(endpoints.WHATSAPP_WBA_CLOUD),
}
